import { useContext } from 'react';

import AuthContext, { AuthContext as IAuthContextContext } from './Auth.context';

export const useAuth = () => useContext(AuthContext) as IAuthContextContext;
